import styles from './multiplication.module.scss';

interface MultiplicationProps {
  operandOne: React.ReactNode;
  operandTwo: React.ReactNode;
}

export const Multiplication = ({
  operandOne,
  operandTwo,
}: MultiplicationProps) => {
  return (
    <div className={styles.multiplication}>
      <div className={styles.operand}>{operandOne}</div>
      <div>*</div>
      <div className={styles.operand}>{operandTwo}</div>
    </div>
  );
};
